import React from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import {ExpandComponentProps} from "core/grid/component/gridComp";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import productService from "product/productService";
import {PRICECOMPLEVEL_COLORS, PriceComponent, ProductVehicle, Vehicle} from "product/productDomain";
import {action, ObservableMap} from "mobx";
import {lovLabel, lovValue} from "core/form/formUtils";
import {formatInterval, isValid} from "core/common/utils/dateUtils";
import {grey400} from "material-ui/styles/colors";
import mdEntityService from "core/metamodel/mdEntityService";
import MdEntity from "core/metamodel/mdEntity";
import {GridRow} from "core/grid/domain/grid";

import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/mergeMap';
import MdField from "core/metamodel/mdField";
import {addTenantToQuery} from "core/common/utils/utils";
import moment from "moment";
import {CSSProperties} from "react";

const itemStream = new Subject<any>();
itemStream
  .mergeMap((item) => Promise.all([item, productService.readVehicle(item.rowId as number, true), mdEntityService.fetchEntities(["PriceComponent"])]), null, 5)
  .subscribe(action("subscribe-actionCb", ([item, vehicle, entityMap]: [GridRow, Vehicle, ObservableMap<MdEntity>]) => {
   item.rowObject = vehicle;
   item.expanded = 2;
   console.log("VehicleExpando resolved vehicle %s", vehicle.vehicleId);
}));


const _productIntervalStyle: CSSProperties = {
  fontStyle: 'italic',
  color: grey400
};

@observer
export default class VehicleExpando extends React.Component<ExpandComponentProps, null> {


  componentDidMount() {
    let {item} = this.props;
    const vehicle = item.rowObject as Vehicle;
    //console.log("VehicleExpando componentDidMount, missing data going to add to resolver: " + (!vehicle || !vehicle.productVehicles));
    if (!vehicle) {
      itemStream.next(item);
    }
  }

  // VirtualList reuse components, because they have the same key, only data are changed in componentDidUpdate
  componentDidUpdate(prevProps, prevState) {
    let {item} = this.props;
    const vehicle = item.rowObject as Vehicle;
    //console.log("VehicleExpando componentDidUpdate, prev rowId = %O, new rowId = %O, missing data going to add to resolver: " + (!vehicle || !vehicle.productVehicles) ,
    //  prevProps.item.rowId, item.rowId);
    if (!vehicle && prevProps.item.rowId !== item.rowId ) {
      itemStream.next(item);
    }
  }


  render() {
    let {item} = this.props;
    const vehicle = item.rowObject as Vehicle;

    //console.log("VehicleExpando render vehicle %s, expanded = %s", (vehicle)?vehicle.vehicleId:null, item.expanded);

    const priceComponentEntity = mdEntityService.getEntity("PriceComponent");
    const priceField = (priceComponentEntity) ? priceComponentEntity.getField("price") : null;


    const now: moment.Moment = moment().startOf('day');

    if (item.expanded === 1) {
      return (
        <div style={{marginLeft: 24}}><i className="fa fa-refresh fa-2x fa-spin color-blue-grey-200"/></div>
      );
    }

    return (vehicle && vehicle.productVehicles && priceField) ? (
      <div style={{marginLeft: 22, display: 'table', borderSpacing: 4 }}>
        {vehicle.productVehicles.map(pv => {

          const _productStyle = {display: 'table-cell', paddingRight: 10};
          if (!isValid(pv, now)) _productStyle["color"] = grey400;

          return (
            <div key={lovValue(pv.product)} style={{display: 'table-row'}}>
              <div style={_productStyle}>
                <span>{lovLabel(pv.product)}</span>
                <span style={_productIntervalStyle}>{' ' + formatInterval(pv.validFrom, pv.validTo)}</span>
              </div>
              {(pv.prices) ? pv.prices.map(pc => <PriceBox key={pc.priceComponentId} pv={pv} pc={pc} priceField={priceField} /> ): null}
            </div>
          )
        })}
      </div>
    ) : null;
  }

}


interface PriceBoxProps {
  pv?: ProductVehicle;
  pc: PriceComponent;
  priceField: MdField;
  disableLink?: boolean;
  style?: any;
}

export class PriceBox extends React.Component<PriceBoxProps, undefined> {
  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  private routeName = "priceComponentDetail";

  onClick = (event) => {
    event.preventDefault();
    const {pc} = this.props;
    this.context.router.transitionTo(this.routeName, {id: pc.priceComponentId});
  };

  render() {
    const {pc, pv, priceField, disableLink, style} = this.props;

    const now: moment.Moment = moment().startOf('day');

    const _pcStyle = {display: 'table-cell', borderRadius: 3, border: '1px solid', paddingLeft:5, paddingRight:5, color: PRICECOMPLEVEL_COLORS[lovValue(pc.priceLevel)]};
    if (pv && pc.priceComponentId === pv.activePriceComponentId) {
      _pcStyle["borderWidth"] = 2; _pcStyle["fontWeight"] = "bold";
    }
    if (!isValid(pc, now)) {
      _pcStyle["textDecoration"] = "line-through";
    }
    if (style) {
      Object.assign(_pcStyle, style);
    }

    const content = (pc.priceComponentId && !disableLink) ? (
      <a className="no-link" style={_pcStyle}
         href={this.context.router.makeHref(this.routeName, {id: pc.priceComponentId}, addTenantToQuery())}
         onClick={this.onClick}>
        {priceField.formatValue(pc.price)} {lovLabel(pc.priceCurrency)}
      </a>
    ) : (
      <div style={_pcStyle}>
        {priceField.formatValue(pc.price)} {lovLabel(pc.priceCurrency)}
      </div>
    );

    return (
      <OverlayTrigger placement="top" delayShow={500} overlay={<Tooltip id={pc.id + "_dateIntervalTooltip"}>{formatInterval(pc.validFrom, pc.validTo)}</Tooltip>}>
        {content}
      </OverlayTrigger>
    );

  }

}



// WEBPACK FOOTER //
// ./src/product/component/vehicleExpando.tsx